/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $on = _ref.$on,
      $update = _ref.$update;
  var fulldate = null;
  $on('pageInit', function () {
    // do something on page init
    var app = $f7;
    var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var d = new Date();
    fulldate = d.getDate() + " " + monthNames[d.getMonth()] + " " + d.getFullYear();
    $update();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page no-toolbar" data-name="home">
    <!-- Top Navbar -->
    <!-- <div class="navbar navbar-large">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left">
          <a href="#" class="link icon-only panel-open" data-panel="left">
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div>
        <div class="title sliding">Masjid Pro</div>
        <div class="right">
          <a href="#" class="link icon-only panel-open" data-panel="right">
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div>
        <div class="title-large">
          <div class="title-large-text">Masjid Pro</div>
        </div>
      </div>
    </div> -->

    <!-- Scrollable page content-->
    <div class="page-content" >
      <a href="/">
        <img src="static/images/pass.png" width="100%"/>
      </a>
      

      <div style="position: absolute; top: 300px; font-weight: bold; width: 100%;">
        <table style="margin-left:10%;margin-right: 10%;" width=80%>
          <td class="text-align-right" width=100%>
            ${fulldate}
          </td>
        </table>
      </div>      
    </div>
  </div>
`
    }
    ;
}

framework7Component.id = '2d2ca1e9f5';
export default framework7Component;